export const QuaiEnvironments = ['prod', 'staging', 'dev', 'local'];
export const QuaiEnv_LabelMap = {
    prod: 'Prod',
    staging: 'Staging',
    dev: 'Dev',
    local: 'Local'
};
export const Const_LaunchDeploy = '/launch-deploy';
export const Const_LaunchSmart = '/launch-smart';
export const UrlParam_EnvironmentId = 'environment-id';
export const UrlParam_FacilityId = 'facility-id';
export const createUrl = (envUrl, environmentId, facilityId) => {
    let url = envUrl;
    if (!url.endsWith('/'))
        url += '/';
    url = `${url}launch-smart?environmentId=${environmentId}&facilityId=${facilityId}`;
    return url;
};
//# sourceMappingURL=consts.js.map